import store from "@/store";
import { auth } from "common";
const Base64 = require("js-base64").Base64;
export default function routerPermission(router) {
  router.beforeEach((to, from, next) => {
    let token = auth.getToken();

    let queryInfo = JSON.parse(JSON.stringify(to.query));
    //ifcp_url 单点登录重定向地址
    let ifcp_url = queryInfo.ifcp_url || "";
    //判断单点登录
    if (ifcp_url) {
      if (queryInfo.appCode && queryInfo.tenantCode) {
        store.commit("SET_USER_FLAG", false);
        let login_data = {
          grant_type: "iam_token",
          loginPlat: 3,
          ifcp_url: queryInfo.ifcp_url,
          code: queryInfo.code,
          appCode: queryInfo.appCode,
          tenantCode: queryInfo.tenantCode,
        };
        let encodeTenantCode = "";
        if (queryInfo.tenantCode) {
          encodeTenantCode = auth.tenantCodeEncode(queryInfo.tenantCode);
        }
        store
          .dispatch("Login", login_data)
          .then((data) => {
            let ifcp_url = data.ifcp_url || "";
            auth.saveAppStorage("ifcp_url", Base64.encode(ifcp_url));
            next("/redirectIndex?tenantCode=" + encodeTenantCode);
          })
          .catch(() => {
            next("/redirectIndex?tenantCode=" + encodeTenantCode);
          });
      } else {
        next({ path: "/login" });
        auth.goLogin();
      }
    } else {
      let isNoLogin = to.meta ? to.meta.noLogin : false;
      //userFlag 判断是否获取过用户信息
      let userFlag = store.getters.userFlag;
      if (token || isNoLogin) {
        if (isNoLogin) {
          if (to.path == "/login") {
            auth.goLogin();
          }
          next();
        } else {
          if (!userFlag) {
            store.dispatch("getAppInfo").then((data) => {});
            //GetUserInfo 获取用户基本信息
            store
              .dispatch("GetUserInfo")
              .then((data) => {
                if (data && data.uuid) {
                  //GetUserIdentity获取用户身份列表
                  store
                    .dispatch("GetUserIdentity", data.uuid)
                    .then(([identityData, identityOrg]) => {
                      //判断当前用户当前身份是否有组织机构信息
                      if (identityOrg) {
                        store.dispatch("GetMenu").then((data) => {
                          menuPath(to, next);
                        });
                      } else {
                        next("/nopriv");
                      }
                    })
                    .catch(() => {
                      next("/nopriv");
                    });
                } else {
                  next("/nopriv");
                }
              })
              .catch(() => {
                next("/nopriv");
              });
          } else {
            menuPath(to, next);
          }
        }
      } else {
        next("/login");
        auth.goLogin();
        // auth.loginOut();
      }
    }
  });
}
/**根据获取的菜单信息判断跳转路径 */
export function menuPath(to, next) {
  let allPaths = store.getters.allMenuPath || [];
  if (allPaths.length == 0) {
    next({ path: "/nopriv" });
  } else {
    if (to.path == "/") {
      next({
        path: allPaths[0],
      });
    } else {
      if (
        to.meta &&
        to.meta.privCode &&
        auth.validPrivCode(to.meta.privCode) === false
      ) {
        next({ path: "/nopriv" });
      } else {
        next();
      }
    }
  }
}
